import { render, staticRenderFns } from "./new_assignment_view.vue?vue&type=template&id=2c51d14e&"
import script from "./new_assignment_view.vue?vue&type=script&lang=js&"
export * from "./new_assignment_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports